import { IOffer } from '../../../types/offer';
import { isGarage } from '../category/isGarage';

export function isCommercial(offer: IOffer): boolean {
  // Гаражи, машиноместа и боксы (category garageRent | garageSale) — жилые офферы и
  // рендерятся жилым путём, даже когда приходят с offerType 'commercial'. Без этого
  // исключения они уходили бы в коммерческую карточку, у которой нет заголовка типа
  // для гаражной категории, и в шапке оставалась только площадь.
  return offer.offerType === 'commercial' && !isGarage(offer);
}
